import { AppActions, AppActionTypes } from './actions';
import {
  CropVarietySpecificNormFilter,
  LegalNitrogenWorkingCoefficientsFilter,
  PhosphateLegalNormFilter,
  SalesOrderPeriod,
  SiteState,
  TotalNitrogenLegalNormFilter,
} from '../shared/models';

export const initialState = {
  totalNitrogenLegalNormFilter: {} as TotalNitrogenLegalNormFilter,
  legalNitrogenWorkingCoefficientsFilter: {} as LegalNitrogenWorkingCoefficientsFilter,
  cropVarietySpecificNormFilter: {} as CropVarietySpecificNormFilter,
  phosphateLegalNormFilter: {} as PhosphateLegalNormFilter,
  salesOrderPeriods: [] as SalesOrderPeriod[],
};

export function appReducer(state = initialState, action: AppActions): SiteState {
  switch (action.type) {
    case AppActionTypes.LoadCropsSuccess: {
      return {
        ...state,
        crops: action.crops,
      };
    }

    case AppActionTypes.LoadCropVarietiesByCropIdSuccess: {
      return {
        ...state,
        cropVarieties: action.cropVarieties,
      };
    }

    case AppActionTypes.LoadCropAidsSuccess: {
      return {
        ...state,
        cropAids: action.cropAids,
      };
    }

    case AppActionTypes.LoadSalesOrderPeriodsSuccess: {
      return {
        ...state,
        salesOrderPeriods: [...state.salesOrderPeriods, ...action.salesOrderPeriods],
      };
    }

    case AppActionTypes.ClearCropVarieties: {
      return {
        ...state,
        cropVarieties: [],
      };
    }

    case AppActionTypes.LoadSoilTypesSuccess: {
      return {
        ...state,
        soilTypes: action.soilTypes,
      };
    }

    case AppActionTypes.LoadTotalNitrogenLegalNormsSuccess: {
      return {
        ...state,
        totalNitrogenLegalNormPagination: action.pagination,
      };
    }

    case AppActionTypes.UpdateTotalNitrogenLegalNormFilter: {
      return {
        ...state,
        totalNitrogenLegalNormFilter: {
          ...state.totalNitrogenLegalNormFilter,
          ...action.totalNitrogenLegalNormFilter,
        },
      };
    }

    case AppActionTypes.ClearTotalNitrogenLegalNormFilter: {
      return {
        ...state,
        totalNitrogenLegalNormFilter: {},
      };
    }

    case AppActionTypes.LoadLegalNitrogenWorkingCoefficientsSuccess: {
      return {
        ...state,
        legalNitrogenWorkingCoefficientsPagination: action.pagination,
      };
    }

    case AppActionTypes.UpdateLegalNitrogenWorkingCoefficientsFilter: {
      return {
        ...state,
        legalNitrogenWorkingCoefficientsFilter: {
          ...state.legalNitrogenWorkingCoefficientsFilter,
          ...action.legalNitrogenWorkingCoefficientsFilter,
        },
      };
    }

    case AppActionTypes.ClearLegalNitrogenWorkingCoefficientsFilter: {
      return {
        ...state,
        legalNitrogenWorkingCoefficientsFilter: {},
      };
    }

    case AppActionTypes.LoadCropVarietySpecificNormsSuccess: {
      return {
        ...state,
        cropVarietySpecificNormPagination: action.pagination,
      };
    }

    case AppActionTypes.UpdateCropVarietySpecificNormFilter: {
      return {
        ...state,
        cropVarietySpecificNormFilter: {
          ...state.cropVarietySpecificNormFilter,
          ...action.cropVarietySpecificNormFilter,
        },
      };
    }
    case AppActionTypes.ClearCropVarietySpecificNormFilter: {
      return {
        ...state,
        cropVarietySpecificNormFilter: {},
      };
    }

    case AppActionTypes.LoadPhosphateLegalNormsSuccess: {
      return {
        ...state,
        phosphateLegalNormPagination: action.pagination,
      };
    }

    case AppActionTypes.UpdatePhosphateLegalNormFilter: {
      return {
        ...state,
        phosphateLegalNormFilter: {
          ...state.phosphateLegalNormFilter,
          ...action.phosphateLegalNormFilter,
        },
      };
    }

    case AppActionTypes.ClearPhosphateLegalNormFilter: {
      return {
        ...state,
        phosphateLegalNormFilter: {},
      };
    }

    default: {
      return state;
    }
  }
}
